import { CartOrder } from 'cart-core';
import { InputTextField } from 'forms';
import React, { ChangeEvent } from 'react';
import t from '@rcm/i18n-client';

interface Props {
  disabled: boolean;
  error: any;
  onValueChange: (value: string, oldValue: string, name: string, event: ChangeEvent<HTMLInputElement>) => void;
  order: CartOrder;
  value: string;
}

const CreditCardVerificationCodeField = ({ disabled, error, onValueChange, order, value }: Props) => {
  return (
    order.attributes.isCountryRequireCvv && (
      <InputTextField
        className="ccVerCode"
        autoComplete="off"
        disabled={disabled}
        error={error}
        label={t('Verification Code')}
        name="creditCard[verificationCode]" // Used by tests
        onValueChange={onValueChange}
        value={value}
      />
    )
  );
};

export default CreditCardVerificationCodeField;
